import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-7 gap-4 pb-2\"><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\"> Tier </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\"> Dimulai Dari </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\"> Sampai </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\"> Komisi Induk </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\"> Komisi cabang </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\"> Komisi di Pick Up </div><div class=\"w-12/12 font-semibold text-12px xxl:text-14px text-center\"> Komisi Pick Up </div></div><div class=\"border-t\"></div>", 2)
const _hoisted_5 = { class: "grid grid-cols-7 gap-4" }
const _hoisted_6 = { class: "w-12/12 text-center" }
const _hoisted_7 = { class: "w-12/12" }
const _hoisted_8 = { class: "w-12/12" }
const _hoisted_9 = { class: "w-12/12" }
const _hoisted_10 = { class: "w-12/12" }
const _hoisted_11 = { class: "w-12/12" }
const _hoisted_12 = { class: "w-12/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, { label: "Perhitungan Tier" }),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.isCalculationTierValid) + " ", 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.commissionCalculationTier, (tierCalculation, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "flex flex-wrap flex-row items-center py-6 border-b"
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(index + 1), 1),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_lp_input, _mergeProps({
                error: 
                _ctx.isErrorStartEndAmount(index) || _ctx.isErrorStartIntersection(index)
              ,
                "error-icon": false
              }, _ctx.startEndAmountType, {
                format: _ctx.formatNumber,
                modelValue: tierCalculation.startAmount,
                "onUpdate:modelValue": ($event: any) => (tierCalculation.startAmount = $event),
                maxValueNumber: _ctx.maxStartEndValue
              }), null, 16, ["error", "format", "modelValue", "onUpdate:modelValue", "maxValueNumber"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_lp_input, _mergeProps({
                error: 
                _ctx.isErrorStartEndAmount(index) || _ctx.isErrorEndIntersection(index)
              ,
                "error-icon": false
              }, _ctx.startEndAmountType, {
                format: _ctx.formatNumber,
                modelValue: tierCalculation.endAmount,
                "onUpdate:modelValue": ($event: any) => (tierCalculation.endAmount = $event),
                maxValueNumber: _ctx.maxStartEndValue
              }), null, 16, ["error", "format", "modelValue", "onUpdate:modelValue", "maxValueNumber"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_lp_input, _mergeProps({
                "error-icon": false,
                error: _ctx.isErrorCommissionAmount(index)
              }, _ctx.commissionAmountType, {
                format: _ctx.formatCommissionAmount,
                modelValue: tierCalculation.commissionAmount,
                "onUpdate:modelValue": ($event: any) => (tierCalculation.commissionAmount = $event),
                maxValueNumber: _ctx.maxCommissionValue
              }), null, 16, ["error", "format", "modelValue", "onUpdate:modelValue", "maxValueNumber"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_lp_input, _mergeProps({
                "error-icon": false,
                error: _ctx.isErrorCommissionAmountBranch(index)
              }, _ctx.commissionAmountType, {
                format: _ctx.formatCommissionAmount,
                modelValue: tierCalculation.commissionAmountBranch,
                "onUpdate:modelValue": ($event: any) => (tierCalculation.commissionAmountBranch = $event),
                maxValueNumber: _ctx.maxCommissionValue
              }), null, 16, ["error", "format", "modelValue", "onUpdate:modelValue", "maxValueNumber"])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_lp_input, _mergeProps({
                "error-icon": false,
                error: _ctx.isErrorCommissionAmountPickup(index)
              }, _ctx.commissionAmountType, {
                format: _ctx.formatCommissionAmount,
                modelValue: tierCalculation.commissionAmountPickup,
                "onUpdate:modelValue": ($event: any) => (tierCalculation.commissionAmountPickup = $event),
                maxValueNumber: _ctx.maxCommissionValue
              }), null, 16, ["error", "format", "modelValue", "onUpdate:modelValue", "maxValueNumber"])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_lp_input, _mergeProps({
                "error-icon": false,
                error: _ctx.isErrorCommissionAmountPickupPublishRate(index)
              }, _ctx.commissionAmountType, {
                format: _ctx.formatCommissionAmount,
                modelValue: tierCalculation.commissionAmountPickupPublishRate,
                "onUpdate:modelValue": ($event: any) => (tierCalculation.commissionAmountPickupPublishRate = $event),
                maxValueNumber: _ctx.maxCommissionValue
              }), null, 16, ["error", "format", "modelValue", "onUpdate:modelValue", "maxValueNumber"])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}